import { render, staticRenderFns } from "./ConfirmAdministrator.vue?vue&type=template&id=6e00a2b8&"
import script from "./ConfirmAdministrator.vue?vue&type=script&lang=js&"
export * from "./ConfirmAdministrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports